import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Modal, Button, Spinner } from 'react-bootstrap';
import DataTable from 'react-data-table-component';
import { getRequest, downloadFile } from '../../helpers/apiHandler';
import config from '../../config/Constant';
import CustomAlert from '../CustomAlert';
import CloseIcon from '../../layouts/SVG/CloseIcon';
import iconDownload from '../../assets/SidebarIcons/icon-download.svg';
import { sortByDate } from '../../helpers/helperFunction';

const SpamDetailsModel = ({ onShow, userID, setUserID, setSpamDetailsShow }) => {
  const { access_token } = useSelector((state) => state.auth.user);

  const [spamDetails, setSpamDetails] = useState([]);
  const [loadingDownload, setLoadingDownload] = useState(false);
  const [alertState, setAlertState] = useState({
    show: false,
    variant: 'danger',
    message: '',
  });

  const columns = [
    { name: 'Name', sortable: true, selector: (row) => row.name },
    { name: 'Email', sortable: true, selector: (row) => row.email },
    { name: 'User ID', sortable: true, selector: (row) => row.user_id },
    { name: 'Content', sortable: true, selector: (row) => row.message },
    { name: 'Total SMS', sortable: true, selector: (row) => row.total_sms },
    { name: 'Created Date', sortable: true, selector: (row) => row.created_at, sortFunction: sortByDate('created_at') },
    { name: 'Spam Classification', sortable: true, selector: (row) => row.classification },
    { name: 'Spam Score', sortable: true, selector: (row) => row.confidence },
  ];

  useEffect(() => {
    if (onShow) {
      const payload = {
        headers: { Authorization: access_token.token },
        params: { user_id: userID },
      };

      getRequest('/admin/spam-report', payload, (res) => {
        if (res.success) {
          const result = res.data;

          setSpamDetails(result);
        }
      });
    }
  }, [onShow]);

  const handleClose = () => {
    setUserID(null);
    setSpamDetailsShow(false);
    setSpamDetails([]);
  };

  const handleDownload = () => {
    setLoadingDownload(true);
    downloadFile(
      {
        url: '/admin/spam-details-export',
        data: {
          spam_data: spamDetails,
          download_file: true
        },
        access_token: access_token,
        fileName: 'spam-details.csv',
      },
      (res) => {
        if (!res.error) {
          setAlertState({
            message: 'Spam details have been successfully exported to excel.',
            show: true,
            variant: 'success',
          });
          setSpamDetailsShow(false);

        } else {
          setAlertState({
            message: 'We apologize, but it seems there was an issue exporting.',
            show: true,
            variant: 'danger',
          });
        }
        setLoadingDownload(false);
      }
    );
  };

  useEffect(() => {
    if (alertState.show) {
      setTimeout(() => {
        setAlertState({
          message: '',
          show: false,
          variant: '',
        });
      }, config.notify_time);
    }
  }, [alertState]);

  return (
    <>
      <CustomAlert
        message={alertState.message}
        show={alertState.show}
        variant={alertState.variant}
        closeAlert={() => setAlertState({ show: false, variant: 'danger', message: '' })}
      />
      <Modal show={onShow} onHide={handleClose} centered size="xl">
        <Modal.Header>
          <div className="w-100 d-flex justify-content-between align-items-center">
            <Modal.Title as="h4" style={{ margin: '16px 0 8px 8px' }}>
              Spam Activity Details
            </Modal.Title>
            <Button
              variant="primary"
              disabled={loadingDownload}
              style={{ minWidth: 160 }}
              onClick={handleDownload}
            >
              {loadingDownload ? (
                <Spinner animation="border" size="sm" className="mr-2" />
              ) : (
                <img src={iconDownload} alt="..." style={{ marginRight: 8 }} />
              )}
              Export to Excel
            </Button>
          </div>
          <CloseIcon handleModalClose={handleClose} />
        </Modal.Header>
        <Modal.Body className="spam-detail-modal">
          <DataTable columns={columns} data={spamDetails} pagination />
        </Modal.Body>
      </Modal>
    </>
  );
};

export default SpamDetailsModel;
